module.exports = __webpack_public_path__ + "static/Testeira_MaxiPack_6-32f52574dcc39dbe87e3f858656d4c07.jpg";